const map = {
	"./hip/Aufbauhöhe_Unterdach.svg": 9382,
	"./hip/Dach.svg": 8262,
	"./hip/Dachneigung.svg": 9811,
	"./hip/Giebelbreite.svg": 6423,
	"./hip/Höhe.svg": 837,
	"./hip/Schneefangreihen.svg": 5435,
	"./hip/Stützen.svg": 2862,
	"./hip/Trauflänge.svg": 4566,
	"./hip/Walmneigung.svg": 5412,
	"./marker.svg": 9742,
	"./pent/Aufbauhöhe_Unterdach.svg": 3274,
	"./pent/Dach.svg": 4314,
	"./pent/Dachneigung.svg": 6767,
	"./pent/Giebelbreite.svg": 3435,
	"./pent/Höhe.svg": 1409,
	"./pent/Schneefangreihen.svg": 9087,
	"./pent/Stützen.svg": 4074,
	"./pent/Trauflänge.svg": 3746,
	"./saddle/Aufbauhöhe_Unterdach.svg": 5256,
	"./saddle/Dach.svg": 3744,
	"./saddle/Dachneigung.svg": 9153,
	"./saddle/Giebelbreite.svg": 4853,
	"./saddle/Höhe.svg": 5967,
	"./saddle/Schneefangreihen.svg": 4377,
	"./saddle/Stützen.svg": 7148,
	"./saddle/Trauflänge.svg": 7540,
	"./tent/Aufbauhöhe_Unterdach.svg": 7182,
	"./tent/Dach.svg": 9502,
	"./tent/Dachneigung.svg": 8347,
	"./tent/Giebelbreite.svg": 2383,
	"./tent/Höhe.svg": 9597,
	"./tent/Schneefangreihen.svg": 9379,
	"./tent/Stützen.svg": 4582,
	"./tent/Trauflänge.svg": 8910,
	"./tent/Walmneigung.svg": 8076
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2120;